import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  public planificationClick: Observable<Event>;
  public machinesClick: Observable<Event>;
  public logoutClick: Observable<Event>;
  public configurationClick: Observable<Event>;

  public planificationClickSubject: Subject<Event> = new Subject();
  public machinesClickSubject: Subject<Event> = new Subject();
  public logoutClickSubject: Subject<Event> = new Subject();
  public configurationClickSubject: Subject<Event> = new Subject();
  constructor() { 
    this.planificationClick = this.planificationClickSubject.asObservable();
    this.machinesClick = this.machinesClickSubject.asObservable();
    this.logoutClick = this.logoutClickSubject.asObservable();
    this.configurationClick = this.logoutClickSubject.asObservable();
  }
}
